import React from "react";
import "./Realspad_nft.css";
import nft from "../Assets/nft_new.jpeg";
import hit from "../Assets/rnt2.jpeg";

export default function Realspad_nft() {
  return (
    <>
      <div className="main_realspad_nft">
        <div className="container">
          <div className="row align-items-center mt-4" id="comming_nft">
            <div className="col-md-6  text-start">
              <h1 className="lower_tkn text-start ">Upcoming Realspad NFT </h1>
              <p className="nft_para">
              The upcoming launch of Real Estate NFTs promises to be a groundbreaking opportunity. Investors will have the chance to invest in tangible real estate properties through NFTs and earn passive income.
              Each NFT will be backed by a real property, enabling investors to participate in buying, selling, leasing, and renting these properties directly through the blockchain.
              </p>
              <p className="nft_para">
              When leasing a property NFT, investors can earn daily income from rental yields or other forms of returns. There will be a lock-in period of 2 to 3 years, compliant with local regulations. After this period, investors will also receive their initial investment back.
              Transactions for buying and selling properties via NFTs will be conducted in accordance with local laws and regulations.
              All the Transactions will be only through Reals Tokens.
              </p>
              {/* <p className="nft_para fw-bold  ">
              As a special offer, free agricultural land property NFTs will be available for lease to those who purchase Real Tokens valued at $200 or more and stake them on the Realspad platform.
              </p> */}
            </div>
            <div className="col-md-6  mt-3 mt-md-0">
              <img src={nft} className="rounded" alt="" />
            </div>
          </div>
          <div className="row align-items-center mt-5">
            <div className="col-md-6  mt-3 mt-md-0">
              <img src={hit} className="rounded" alt="" />
            </div>
            <div className="col-md-6  text-start mt-3 mt-md-0">
              <h1 className="lower_tkn text-start ">How it works? </h1>
              <p className="nft_para">
                Investors pool funds and invest in RealsPad project. RealsPad
                issues Realspad(Reals Token)s to investors in proportion to
                their invested amount. Investors can choose to stake their
                tokens, hold them, or exchange them in the open market.
              </p>
              <ul>
                <li className="hw_lis fw-blod">
                  Staked tokens are used by RealsPad for various purposes:
                </li>
                <li className="hw_lis">
                  <span className="fw-bold"> 
                  Acquisition of properties::</span>{" "}
                  RealsPad acquires properties with committed funds.
                </li>
                <li className="hw_lis">
                  <span className="fw-bold"> Leasing of properties: </span>{" "}
                  The acquired properties are leased by RealsPad in order to generate rental income.
                </li>
                <li className="hw_lis">
                  <span className="fw-bold"> Development of sites: </span>{" "}
                  RealsPad employs pledged funds in order to finance the development of properties and sites, thereby augmenting their value.

                </li>
                <li className="hw_lis">
                  <span className="fw-bold">
                    {" "}
                    Marketing at a higher price:{" "}
                  </span>{" "}
                  RealsPad employs a premium pricing strategy in order to attract prospective purchasers or tenants to the properties/sites.

                </li>
                <li className="hw_lis">
                  <span className="fw-bold"> Profit generation: </span> Profit is defined as the revenue generated from property leasing, property
                  transactions, and site development.
                </li>
                <li className="hw_lis">
                  <span className="fw-bold">
                    {" "}
                    Deduction of expenditures:{" "}
                  </span>{" "}
                  Operating Expenditures Deducted from the generated profit are RealsPad's operational expenses, which include marketing costs, maintenance costs, and management fees.
                </li>
                {/* <li className="hw_lis">
                  <span className="fw-bold"> Profit distribution: </span> After
                  deducting the expenditures, RealsPad distributes a portion of
                  the remaining profit to the token stakers. Token stakers
                  receive their share of profit according to the number of
                  tokens they stake. Investors can choose to reinvest their
                  profits, sell their tokens on the open market, or hold them
                  for future participation in the project. Realspad(Reals Token)
                  TOKENOMICS
                </li> */}
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div className="main_realspad_nft pt-4">
        <div className="container">
          <h4 className="text-center txt_clr site_font fw-bold fs-2">
            Functions of Reals Tokens
          </h4>
          <div className="row">
            <div className="col-md-6 ">
              <div className="product_card firs_ro">
                <h5 className="txt_clr fs-3 fw-semi-bold site_font">
                  Stability Backed by Assets:
                </h5>
                <p className="txt_clr fs-6  site_font">
                  Reals Token, in contrast to numerous alternative
                  cryptocurrencies, is supported by tangible real estate assets.
                  This characteristic ensures a consistent value and mitigates
                  the inherent volatility frequently observed in digital
                  currencies.
                </p>
              </div>
            </div>
            <div className="col-md-6  mt-3 mt-md-0">
              <div className="product_card firs_ro">
                <h5 className="txt_clr fs-3 fw-semi-bold site_font">
                  Concealed Transactions:
                </h5>
                <p className="txt_clr fs-6  site_font">
                  By capitalizing on the streamlined operations of the Binance
                  Smart Chain, Reals Token facilitates expeditious and
                  economical transactions, thereby guaranteeing smooth
                  communication within the Realspad ecosystem.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-4 ">
            <div className="col-md-4 ">
              <div className="product_card secnd_ro">
                <h5 className="txt_clr fs-3 fw-semi-bold site_font">
                  The Generation of Yield:
                </h5>
                <p className="txt_clr fs-6  site_font">
                  By means of novel mechanisms including real estate secured by
                  NFTs, Reals Token provides users with the chance to generate
                  passive income via assets of Realspad Govern Reals Tokens &
                  NFTs by staking, Buying, Selling, leasing and renting the Real
                  properties backed Reals tokens & NFTs.
                </p>
              </div>
            </div>
            <div className="col-md-4  mt-3 mt-md-0">
              <div className="product_card secnd_ro">
                <h5 className="txt_clr fs-3 fw-semi-bold site_font">
                  Governance Involvement:
                </h5>
                <p className="txt_clr fs-6  site_font">
                  Reals Token holders are granted the authority to engage in
                  governance deliberations within the Realspad ecosystem,
                  thereby promoting a community-oriented and democratic
                  methodology towards the advancement and transformation of the
                  platform.
                </p>
              </div>
            </div>
            <div className="col-md-4  mt-3 mt-md-0">
              <div className="product_card secnd_ro">
                <h5 className="txt_clr fs-3 fw-semi-bold site_font">
                  Real world assets (RWA)
                </h5>
                <p className="txt_clr fs-6  site_font">
                  Reals Token leverages the power of blockchain technology to
                  tokenize real world assets (RWA), enabling seamless
                  digitization and fractional ownership of properties. Reals
                  Token is a revolutionary platform that leverages blockchain
                  technology to tokenize real world assets (RWA), enabling
                  fractional ownership and democratized access to the global
                  real estate market.
                </p>
              </div>
            </div>
          </div>
          <div className="row mt-4 ">
            <div className="col-md-6 ">
              <div className="product_card lst_ro card_bg_img">
                <h5 className="txt_clr fs-3 fw-semi-bold site_font">
                Benefits of staking
                </h5>
                <p className="txt_clr fs-6  site_font">
                Leverage the potential of passive income with the staking options on Realspad. Reals Tokens staked for a 30-day hold duration will accrue a competitive APY of 1%. Maximize your returns by extending your commitment to 90 days and benefiting from an increased APY of 2.5 percent. Those in search of greater returns may choose a 180-day lock duration and earn a remarkable APY of 6%. 
                </p>
              </div>
            </div>
            <div className="col-md-6  mt-3 mt-md-0">
              <div className="product_card lst_ro card_img_2">
                <h5 className="txt_clr fs-3 fw-semi-bold site_font">
                Distribution of profits
                </h5>
                <p className="txt_clr fs-6  site_font">
                RealsPad allocates a fraction of the residual profit to the token stakers subsequent
to the deduction of expenses. Profit is distributed to token stakers in proportion to
the quantity of tokens wagered. Profits may be reinvested, tokens may be sold on
the open market, or tokens may be retained for future project participation.
                </p>
              </div>
            </div>
          </div>
        </div>

        {/* <div className="nimers mt-3">
          <div className="row m-0">
            <div className="col-md-4 pad_side ">
              <div className="white_box_mata">
                <h3 className="txt_clr site_font fs-1 fw-bold ">$580.59M+</h3>
                <p className="txt_clr site_font   ">Total Value Locked</p>
              </div>
            </div>
            <div className="col-md-4 pad_side  mt-3 mt-md-0">
              <div className="white_box_mata">
                <h3 className="txt_clr site_font fs-1 fw-bold ">24.90M+</h3>
                <p className="txt_clr site_font   ">Transactions on Chains</p>
              </div>
            </div>
            <div className="col-md-4 pad_side  mt-3 mt-md-0">
              <div className="white_box_mata">
                <h3 className="txt_clr site_font fs-1 fw-bold ">270</h3>
                <p className="txt_clr site_font   ">Ecosystem Projects</p>
              </div>
            </div>
          </div>
        </div> */}

        {/* <div className="my-5">

      <h3 className="txt_clr site_font fs-3 text-center fw-semi-bold">The Manta Core Ecosystem Products</h3>
      <p className="txt_clr site_font text-center ">The suite of core Manta products provide all of the fundamental functionality for <br /> all on-chain features in the network.</p>
</div> */}
      </div>
    </>
  );
}
